<template>
  <li>
    <template v-if="item.deleted">
      <span :class="{deleted: item.deleted}">{{ item.name }}</span>
    </template>
    <template v-else>
      {{ item.name }}
    </template>
    <channel-advertising-provider-channel-group-label
        :has-business-models="item.has_business_models"
        :business-models="item.business_models"
        @show-business-models="$emit('show-business-models', arguments[0])"
    />
    <span v-if="item.hd" class="stitek"> HD </span>
    <span v-if="catchup" class="catchup_set">{{ catchupHours }} h</span>
    <span v-if="timeshiftSet" :class="timeshiftClass" :title="timeshiftTitle"></span>
    <span v-if="pvrSet" :class="pvrClass"></span>
    <span v-if="periodicPvrSet" :class="periodicPvrClass"></span>
  </li>
</template>

<script>
import nonlinearSettingsInfo from "@/components/mixins/nonlinear-settings-info"
import ChannelAdvertisingProviderChannelGroupLabel from "./ChannelAdvertisingProviderChannelGroupLabel.vue";

export default {
  name: "ListItemChannelBasicInfo",
  components: { ChannelAdvertisingProviderChannelGroupLabel },
  mixins: [nonlinearSettingsInfo],
  props: {
    item: Object,
    orderNumber: [String, Number]
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/ListItemChannelBasicInfo.vue